// Copyright © 2024 The Things Network Foundation, The Things Industries B.V.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import { LOGOUT_FAILURE } from '@console/store/actions/logout'

const defaultState = {
  user: undefined,
  error: undefined,
  rights: undefined,
}

const user = (state = defaultState, { type, payload }) => {
  switch (type) {
    case LOGOUT_FAILURE:
      return {
        ...state,
        error: payload,
      }
    default:
      return state
  }
}

export default user
